import { QuillEditor } from "@pathwright/blocks/src/shared"
import {
  blocksFontCSS,
  serifStyles
} from "@pathwright/blocks/src/ui/typography"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import styled from "styled-components"
import { ButtonEditButton } from "../Button/ui"
import { SubmitInnerUI } from "../Submit/ui"

const MeetingEditWrap = styled(Content.Container)`
  .TextArea__input textarea {
    border: 1px solid rgba(0, 0, 0, 0.4) !important;
    border-radius: 4px;
    overflow-y: hidden;
  }

  ${blocksFontCSS({ type: "serif", size: 20 })}

  .ql-editor {
    text-align: center;
  }

  .TextArea__input textarea::placeholder,
  .ContentText .ql-editor.ql-blank::before,
  .ContentText .ql-editor.ql-blank p .ql-editor.ql-blank::before,
  .ql-editor.ql-blank p {
    color: rgba(0, 0, 0, 0.4);
  }

  /* Ignore block styles */
  .ql-editor,
  .ql-editor p {
    color: #292e35;
  }

  .TextArea .TextArea__input textarea {
    font-style: normal;
  }
`

const StyledInput = styled.div`
  position: relative;
  width: 100%;
  margin: 5px auto 0;
  max-width: 600px;
  padding: 5px;
  border: none;
  background-color: transparent;

  /* Solves Safari printing bug */
  @media print {
    height: 0;
  }

  .ContentText .ql-container,
  .ContentText .BlockText {
    line-height: 25px;
    ${serifStyles({ size: 16 })}
    color: #292e35;
    text-align: center;
  }

  .ql-editor.ql-blank::before {
    content: none;
  }

  .ql-editor.ql-blank::after,
  .ContentText .BlockText.quill-editor-noneditable--placeholder {
    color: rgba(0,0,0,0.6) !important;
    font-size: 16px !important;
    font-style: italic;
    pointer-events: none;
    display: block;
    font-family: var(--chakra-fonts-body);
  }

  .ContentText .BlockText.quill-editor-noneditable--placeholder {
    height: 27.28px;
    opacity: 1 !important;
  }

  .ql-editor.ql-blank::after {
    margin-top: -1.42rem;
    content: attr(data-placeholder);
  }
`

const ButtonWrapper = styled.div`
  margin: 1rem 0;
  display: flex;
  justify-content: center;

  .TextInput {
    margin-right: 0.7rem;
  }
`

const MeetingEdit = (props) => {
  const { data, onChange } = props
  const { link, description, buttonLabel, openInNewTab } = data

  const handleChangeDescription = (description) => onChange({ description })

  return (
    <MeetingEditWrap>
      <SubmitInnerUI>
        <StyledInput>
          <QuillEditor
            toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
            placeholder="Add optional meeting instructions here, such as start time, passcode, etc."
            html={description || ""} // need to pass html prop in case of a rerender
            onChange={handleChangeDescription}
            controlled
          />
        </StyledInput>
        <ButtonWrapper>
          <ButtonEditButton
            buttonLabel={buttonLabel}
            link={link}
            openInNewTab={openInNewTab}
            onChange={onChange}
          />
        </ButtonWrapper>
      </SubmitInnerUI>
    </MeetingEditWrap>
  )
}

export default MeetingEdit
